import Receipt from 'globalComponents/Receipt'
import React from 'react'

const ParkingReceipt: React.FC = () => {
  return <Receipt origin='passes'/>
}

export default ParkingReceipt